import { LOCALES, URLS } from './constants';

export function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export function getWindowSize() {
  if (typeof window === 'undefined') return { innerWidth: 0, innerHeight: 0 };
  let { innerWidth, innerHeight } = window;
  return { innerWidth, innerHeight };
}

export function addSlash(url) {
  if (url.charAt(0) === '#') {
    return url;
  }
  return url.charAt(0) !== '/' ? '/' + url : url;
}

export function normalizeSeoTitle(title) {
  // remove | Air Wick® US if exists
  if (!title) return title;
  return title.replace(' | Air Wick® US', '');
}

export function wrapText(text) {
  // if is not html wrap in p tag
  if (!text.startsWith('<')) return `<p>${text}</p>`;
  return text;
}

export function getCurrentNodeByLocale(nodes, currentLocaleCode) {
  return nodes?.find((item) => item?.locale === currentLocaleCode) || nodes?.[0];
}

export function getCurrentLocaleByPath(currentPath) {
  const parts = currentPath?.split('/');
  if (parts?.[1] === LOCALES.es.lang) {
    return LOCALES.es.code;
  }

  return LOCALES.us.code;
}

export function getProductsPageSlugByLocaleCode(localeCode) {
  if (localeCode === LOCALES.es.code) {
    return URLS.products.es.url;
  }

  return URLS.products.us.url;
}

export function getHardcodedPathByLocaleCode(page, localeCode) {
  if (!localeCode || !URLS?.[page]) {
    return '/';
  }

  if (localeCode === LOCALES.es.code) {
    return URLS[page].es.fullUrl;
  }

  return URLS[page].us.fullUrl;
}
